<div class="tooltip-section" *ngIf="config.tooltip">
    <label>{{ config.labelTooltip }}</label>
    <mat-icon
        matTooltip="Orientação de preenchimento: {{ config.tooltipText }}"
        matTooltipPosition="above">
        help_outline
    </mat-icon>
</div>

<mat-form-field
    appearance="outline"
    [formGroup]="formGroup"
    style="margin-bottom: -1.25em; width: 100%"
>
    <mat-label>{{ config.label }}</mat-label>

    <div>
        <mat-select
            [formControl]="controle"
            [multiple]="config.multiple"
            (selectionChange)="atualizaControle($event)"
            matTooltip="{{ getTooltipAdaptado() }}"
        >
            <mat-select-trigger *ngIf="config.multiple">
                {{ textoResumido }}
            </mat-select-trigger>

            <mat-option *ngIf="!config.multiple">
                Selecione
            </mat-option>

            <input 
               *ngIf="!config.esconderFiltro"
                matInput
                type="text"
                placeholder="Filtro"
                (keyup)="filtrarValores($event.target.value)"
                style="padding: 16px; width: 94%; font-size: inherit"
            />

            <input
                matInput
                type="text"
                placeholder="Limpar seleção"
                *ngIf="config.multiple && controle.value?.length"
                (click)="limparSelecao($event)"
                style="padding: 16px; width: 94%; font-size: inherit; cursor: pointer;"
            />

            <mat-option
                *ngFor="let option of listaCompleta"
                [value]="option.value"
                [hidden]="!isVisivel(option)"
                matTooltip="{{ option.text }}"
            >
                {{ option.text }}
            </mat-option>

        </mat-select>
    </div>
</mat-form-field>
